import { render, staticRenderFns } from "./OfflineExam.vue?vue&type=template&id=74f04872"
import script from "./OfflineExam.vue?vue&type=script&lang=js"
export * from "./OfflineExam.vue?vue&type=script&lang=js"
import style0 from "./OfflineExam.vue?vue&type=style&index=0&id=74f04872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports